import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import axios from "axios";
import PhoneInput, {
  formatPhoneNumber,
  isValidPhoneNumber,
} from "react-phone-number-input";
import assets from "../../assets";

const PopForm = ({ popUpActive, setPopUpActive }) => {
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const [data, setData] = useState({
    name: "",
    email: "",
    linkedin: "",
    github: "",
    telegram: "",
    organization: "",
    text: "",
    typeForm: popUpActive,
  });

  const handleInputChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    });
  };

  const [checkPhone, setCheckPhone] = useState("");

  useEffect(() => {
    try {
      if (isValidPhoneNumber(checkPhone)) {
        return setData({ ...data, veriPhone: formatPhoneNumber(checkPhone) });
      } else {
        return setData({ ...data, veriPhone: "" });
      }
    } catch (error) {
      console.log(error);
      console.clear();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkPhone]);

  const [formLoading, setFormLoading] = useState(false);

  const urlHook = "https://hook.us1.make.com/tq59sweodsmxxjjw1b10kget1ulbgp68";
  const form = useRef(null);

  const onSubmit = async (formData) => {
    formData.preventDefault();

    if (!isValidPhoneNumber(checkPhone)) {
      return false;
    }

    console.log(formData);
    setFormLoading(true);
    setError("");

    try {
      await axios
        .post(urlHook, data, {
          Accept: "application/json",
          "Content-Type": "application/json",
        })
        .then(function (response) {
          form.current.reset();
          //Success ----------------------------------------------------
          console.log(response);
          setError("");
          setSuccess(true);
        })

        //End Succes ----------------------------------------------------
        .catch(function (error) {
          //Error ----------------------------------------------------
          console.log(error.response.data.message);
          console.log("Have a problem");
          setError("Have a problem with send data");
          setFormLoading(false);
        });
      //End Error ----------------------------------------------------
    } catch (error) {
      console.log("Form Error");
      setError("Have a problem with send data");
      setFormLoading(false);
      try {
        // eslint-disable-next-line no-undef
        gtag("event", "Forms", {
          event_category: "Form Error",
          event_label: `${error}`,
        });
      } catch (errorC) {
        console.log(errorC);
      }
    }
  };

  return (
    <div
      className={
        (popUpActive.active ? "popActive " : "") +
        "pop flex flexCol justifyCenter alignCenter"
      }
    >
      <div className="popUp flex flexCol">
        <img className="popLight" src={assets.light.popLight} alt="Light" />
        <div
          className="closeIcon"
          onClick={() => setPopUpActive({ ...data, active: false })}
        >
          <span></span>
          <span></span>
        </div>
        <div className="containPop flex flexCol alignCenter">
          {popUpActive.type === "build" && (
            <h2 className="flex flexRow">
              Build Now{" "}
              <svg
                width="79"
                height="36"
                viewBox="0 0 79 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M33.726 34.6171L48.4471 1.4947L45.084 0L30.3629 33.1224L33.726 34.6171ZM18.6246 5.72878L5.20468 19.1487L18.6246 32.5686L16.0222 35.1709L1.30117 20.4498L0 19.1487L1.30117 17.8475L16.0222 3.12644L18.6246 5.72878ZM60.1831 32.5687L73.603 19.1488L60.1831 5.72895L62.7855 3.12661L77.5065 17.8477L78.8077 19.1488L77.5065 20.45L62.7855 35.1711L60.1831 32.5687Z"
                  fill="#D9D9D9"
                />
              </svg>
            </h2>
          )}
          {popUpActive.type === "white" && (
            <h2 className="flex flexRow">Apply to whitelist</h2>
          )}
          {popUpActive.type === "brain" && (
            <div className="flex flexCol">
              {assets.icons.brain}
              <h2 className="flex flexRow">ECON Brain</h2>
            </div>
          )}
          <form
            ref={form}
            className="form flex flexCol justifyCenter alignCenter"
            onSubmit={(e) => onSubmit(e)}
          >
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Name: Satoshi Nakamoto"
              value={data.name}
              maxLength={80}
              onChange={handleInputChange}
              required
            />
            <PhoneInput
              className={
                checkPhone && !isValidPhoneNumber(checkPhone)
                  ? "errorInput"
                  : ""
              }
              placeholder="Phone: +1 12345678"
              value={checkPhone}
              onChange={setCheckPhone}
              autoComplete="off"
              required
            />
            <input
              type="email"
              name="email"
              id="email"
              placeholder="Email: Satoshi.Nakamoto@*****.com"
              onChange={handleInputChange}
              required
            />
            <input
              type="text"
              name="linkedin"
              id="linkedin"
              placeholder="Your Linkedin URL"
              value={data.linkedin}
              onChange={handleInputChange}
              required
            />

            {popUpActive.type === ("brain" && "build") && (
              <input
                type="text"
                name="github"
                id="github"
                placeholder="Github URL"
                value={data.github}
                onChange={handleInputChange}
                required
              />
            )}

            <input
              type="text"
              name="telegram"
              id="telegram"
              placeholder="Telegram username"
              value={data.telegram}
              onChange={handleInputChange}
              required
            />
            {popUpActive.type === "build" && (
              <input
                type="text"
                name="organization"
                id="organization"
                placeholder="Organization URL"
                value={data.organization}
                onChange={handleInputChange}
                required
              />
            )}

            <div className="flex flexCol alignCenter justifySpace radioDiv">
              <div className="flex flexCol">
                <p>
                  {popUpActive.type === "white" &&
                    "Select what best matches your whitelist profile:"}
                  {popUpActive.type === "brain" &&
                    "Tell us about your background in the blockchain space:"}
                  {popUpActive.type === "build" && (
                    <>Tell us about your project &nbsp;{data.text.length}/250</>
                  )}
                </p>
              </div>
              {popUpActive.type === "white" && (
                <div className="radios flex flexRow ">
                  <input
                    label="Validator"
                    type="radio"
                    name="profile"
                    value="Validator"
                    defaultChecked
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    label="VC Fund"
                    type="radio"
                    name="profile"
                    value="VC Fund"
                    onChange={handleInputChange}
                    required
                  />
                </div>
              )}
              {(popUpActive.type === "brain" ||
                popUpActive.type === "build") && (
                <textarea
                  name="text"
                  maxLength={250}
                  onChange={handleInputChange}
                ></textarea>
              )}
            </div>

            <div className="errores flex flexCol">
              <span className="error">
                {checkPhone &&
                  !isValidPhoneNumber(checkPhone) &&
                  "Ups, your phone number is icorrect"}
              </span>
              <span className="error">{error}</span>
            </div>

            <div className="success flex flexCol">
              <span>{success && "Thank you! Your data has been sent"}</span>
            </div>

            {/*  <pre style={{width:'100%', overflowWrap: 'break-word'}}>
                                        <code style={{ whiteSpace: 'pre-wrap'}}>

                                    {
                                        JSON.stringify(data)
                                    }
                                        </code>

                                    </pre>  */}

            <button
              className={formLoading ? "boton loadBoton" : "boton"}
              type="submit"
            >
              {formLoading ? "Sending..." : "Go!"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PopForm;
